<template>
    <v-container fluid class="NavBar-mainContainer pa-0">  <!-- uso de clases css class="componente-nombreClase"-->
     <v-row class="d-flex" cols="12" no-gutters>
        <v-col class="d-flex pa-0">
          <v-toolbar color="#1460AA" class="NavBar-toolBarContent pa-0">
              <!-- inicio de Home -->
              <v-toolbar-title class="d-flex NavBar-Home align-start justify-center">
                  <v-btn text @click='openComponent("Home")' v-if="userData.onboarding == true">
                      <img src="../assets/Icon_Bell_Home.svg" alt="">
                    </v-btn>
                </v-toolbar-title>
              <!-- fin de Home -->
              <v-toolbar-items class="d-flex NavBar-userItemsContainer align-center justify-center">

                  <!-- inicio de Nombre de Usuario -->
                  <span class="d-flex NavBar-name align-center justify-center">
                          {{userData.firstName}} {{userData.lastName}}</span>
                  <!-- fin de Nombre de Usuario -->

                  <!-- inicio de Menu/Foto de Usuario -->
                  <v-badge right overlap color="#FF006A"
                           class="d-flex NavBar-badge align-end justify-end">
                      <!-- inicio de Notificacion -->
                      <template v-slot:badge>
                        <span>2</span>
                      </template>
                      <!-- fin de Notificacion -->
                    <v-menu
                    v-model="userMenuOpen"
                    :offset-y="true"

                    class="NavBar-userConfigurationMenu"
                    >
                    <template v-slot:activator="{ on }">
                      <v-btn class="mx-2" fab small tile outlined color="#1460AA">
                        <img src="../assets/User.png" alt="" v-on="on">
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in userMenuItems"
                        :key="index" @click='openComponent(item.components)' class="NavBar-listItemUserOptions">
                        <v-list-item-title class="NavBar-listItemUserOptionsTitle">{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    </v-menu>
                  </v-badge>
                  <!-- fin de Menu/Foto de Usuario -->
              </v-toolbar-items>
          </v-toolbar>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import firebase from '../firebase'
  export default {
    name: 'NavBar',
      data () {
        return {
          dialog: false,
          userMenuOpen: false,
          nav: [
              {
              icon: 'home',
              text: 'Inicio',
              title: 'Inicio',
              component: 'Home',
              active: true
              },
              {
              icon: 'info',
              text: 'Vacas',
              title: 'Vacas',
              component: 'DashCow',
              active: false
              },
              {
              icon: 'assignment_turned_in',
              text: 'Grupo',
              title: 'Grupo',
              component: 'DashGroup',
              active: false
              },
              {
              icon: 'email',
              text: 'Validación de alertas',
              title: 'Validación de alertas',
              component: 'ActivateAlerts',
              active: false
              },
              {
                icon: 'email',
                text: 'Eventos confirmados',
                title: 'Eventos confirmados',
                component: 'DashAlert',
                active: false
              }
  
          ],
          userMenuItems: [
            {
              title: 'Configurar mi perfil',
              components: 'UserProfile'
            },
            {
              title: 'Configurar mi rancho',
              components: 'RanchConfiguration'
            },
            { title: 'Mensajes Recibidos'},
            {
              title: 'Administrar usuarios',
              components: 'UserAdministration'
            },
            {
              title: 'Cambiar Plan',
              components: 'UserType'
            },
            { title: 'Cerrar Sesión' },
          ],
          showMenu: false,
          cowMenuOpen: false
        }
    },
    components: {
    },
    computed: {
      userData(){
        return this.$store.getters.getUserData
      }
    },
    methods: {
      toggleMenu(){
        this.showMenu = !this.showMenu;
      },
      openComponent(component){
        this.$router.push({name:component})
      },
      signOut() {
          console.log('aiosh!');
          this.$store.commit('userData', undefined);
          this.$router.push({name:'Login'});
  
          firebase.auth().signOut().then(()=> {
          this.$router.push({name:'Login'});
        }).catch(function(error) {
          console.log(error)
        });
      }
    },
    mounted () {
    }
  };
  </script>
  
  <style lang="css">
    @import '../style/MobileNavBarTop.css';
  </style>
  